import { makeMarkdownText } from '@assistant-ui/react-ui';
import remarkGfm from 'remark-gfm';
import { cn } from '../../lib/cn';
import { MarkdownLink } from '../ui/markdown-link';

export const MarkdownText = makeMarkdownText({
  remarkPlugins: [remarkGfm],
  // Open external links in a new tab (MarkdownLink) while preserving
  // assistant-ui's own `aui-md-a` styling — overriding `components.a`
  // replaces assistant-ui's default anchor, which is what applies that class.
  components: {
    a: ({ className, ...props }) => (
      <MarkdownLink className={cn('aui-md-a', className)} {...props} />
    ),
  },
});
